import { default as NextLink, LinkProps } from 'next/link';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';
import omit from '@frontastic/common/src/js/helper/omit';
import { usePageLoading } from '@frontastic/catwalk/js/helper/hooks/usePageLoading';
import React, { AnchorHTMLAttributes, MouseEventHandler, PropsWithChildren } from 'react';

interface RouterLink
  extends PropsWithChildren<Omit<LinkProps, 'href'>>,
    Omit<AnchorHTMLAttributes<HTMLAnchorElement>, keyof LinkProps> {
  to: LinkProps['href'];
}

// @COFIXME[routing](FLBML-124): Create proper adapter for react-router
export const Link = ({ children, to, onClick, ...rest }: RouterLink) => {
  const childProps = omit(rest, ['to']);
  const { dispatchPageLoadingStart } = usePageLoading();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const newWindow = rest.target === '_blank';

  const onClickWrapper: MouseEventHandler<HTMLAnchorElement> = (event): ReturnType<typeof onClick> => {
    const searchParamsString = searchParams.toString();
    const isSamePath = to === pathname + (searchParamsString ? '?' + searchParams.toString() : '');
    const modKeyPressed = event.ctrlKey || event.metaKey || event.shiftKey || event.altKey;

    if (newWindow !== true && !isSamePath && !modKeyPressed) {
      dispatchPageLoadingStart();
    }

    if (typeof onClick === 'function') {
      return onClick(event);
    }
  };

  return (
    <NextLink href={to} onClick={onClickWrapper} {...childProps}>
      {children}
    </NextLink>
  );
};

export const useHistory = () => {
  const location = useLocation();
  const router = useRouter();

  return { location, push: router.push, replace: router.replace };
};
export const useLink = () => {};
export const useLocation = () => {
  const search = useSearchParams();
  const pathname = usePathname();

  return {
    pathname,
    search: search.toString(),
    get asPath() {
      throw new Error('router.asPath has been removed');
    },
  };
};
